import { PathWithId } from "@constellation-academy/epic-ui";
import { EmailTemplateEditPath } from "../email-template-edit/email-template-edit.paths";

export class EmailTemplatesPath extends PathWithId<typeof EmailTemplatesPath> {
	static readonly pathKey = "emailTemplates";
	static readonly pathName = "email-templates";
	static readonly idKey = "emailTemplateId";
	static readonly childPaths = [EmailTemplateEditPath];
}
